import { SxProps, Theme, alpha } from '@mui/material'

export const dialogSx: SxProps<Theme> = {
  zIndex: 1_800,
}

export const containerSx: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
}

export const contentSx: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: {
    xs: '1.6rem',
    md: '2.4rem',
  },
  gap: '2.4rem',
}

export const titleSectionWrapperSx: SxProps<Theme> = {
  gap: '0.4rem',
}

export const titleSx: SxProps<Theme> = {
  textAlign: 'center',
}

export const titleDescriptionSx: SxProps<Theme> = {
  textAlign: 'center',
}

export const textSx: SxProps<Theme> = {
  fontSize: '1.6rem',
  lineHeight: '2.8rem',
  letterSpacing: '0.044rem',
  fontWeight: 400,
  textAlign: 'center',
  color: (theme) => theme.palette.common.black,
}

export const buttonsWrapperSx = ({
  columnDirection,
}: {
  columnDirection: boolean
}): SxProps<Theme> => {
  return {
    display: 'flex',
    flexDirection: {
      xs: 'column',
      lg: columnDirection ? 'column' : 'row',
    },
    alignItems: {
      xs: 'initial',
      lg: 'center',
    },
    justifyContent: 'center',
    gap: '1.6rem',
  }
}

export const buttonSx: SxProps<Theme> = {
  minWidth: {
    xs: '100%',
    lg: 'auto',
  },
}

export const dialogIconSx: SxProps<Theme> = {
  color: (theme) => theme.palette.secondary.main,
  width: '8.1rem',
  height: '8.1rem',
}

export const firstLineButtonsWrapperSx: SxProps<Theme> = {
  padding: '0.8rem 0.8rem 2.4rem 0.8rem',
  gap: '1.6rem',
}

export const closeIconWrapperSx: SxProps<Theme> = {
  position: 'absolute',
  top: {
    xs: '1.6rem',
    md: '2.4rem',
  },
  right: {
    xs: '1.6rem',
    md: '2.4rem',
  },
  marginTop: '-0.8rem',
  marginRight: '-0.8rem',
  cursor: 'pointer',
}

export const closeIconSx: SxProps<Theme> = {
  color: (theme) => alpha(theme.palette.common.black, 0.54),
  fontSize: '2.8rem',
}
